<template>
  <div>
    <div v-if="!showAdminPanel"></div>
    <app-admin-navigation-toolbar
      v-if="showAdminPanel"
      @changeToPublic="adminPanel = false"
    ></app-admin-navigation-toolbar>
    <v-content class="main-content">
      <slot></slot>
    </v-content>

    <app-footer />
  </div>
</template>

<script>
import AppAdminNavigationToolbar from './sections/AppAdminNavigationToolbar';

import AppFooter from './sections/AppFooter';

export default {
  components: {
    AppAdminNavigationToolbar,
    AppFooter,
  },
  data: () => ({
    adminPanel: false,
  }),

  computed: {
    showAdminPanel() {
      let adminPanel = false;
      let segments = this.$router.currentRoute.fullPath.split('/');
      if (Array.isArray(segments) && segments[1] && segments[1] == 'admin') {
        adminPanel = true;
      }
      return this.$store.state.admin && adminPanel;
    },
  },
};
</script>

<style>
.main-content {
  min-height: 100vh;
}
</style>
